/**
 * Theme custom scripts — extend here without editing core theme JS.
 * Keeps STOQ Preorder CTA in sync after Dawn variant / cart updates.
 */
(function () {
  var PREORDER_LABEL = 'Preorder';
  var observing = false;

  function getStoqSellingPlan(variantId) {
    var rr = window._RestockRocket;
    if (!rr || typeof rr.getSellingPlan !== 'function' || variantId == null || variantId === '') return null;
    try {
      var plan = rr.getSellingPlan(String(variantId)) || rr.getSellingPlan(Number(variantId));
      if (!plan || plan.enabled === false) return null;
      return plan;
    } catch (error) {
      return null;
    }
  }

  function currentVariantId() {
    var input = document.querySelector('product-form input[name="id"]');
    return input && input.value;
  }

  function mergePreorderMaps() {
    window.__yanaPreorderVariants = window.__yanaPreorderVariants || {};
    document.querySelectorAll('[data-yana-preorder-variants]').forEach(function (node) {
      try {
        var map = JSON.parse(node.textContent);
        Object.keys(map).forEach(function (id) {
          window.__yanaPreorderVariants[id] = map[id];
        });
      } catch (error) {
        /* ignore invalid JSON */
      }
    });
  }

  function isPreorderVariant(variantId) {
    if (variantId == null || variantId === '') return false;
    mergePreorderMaps();
    var map = window.__yanaPreorderVariants || {};
    if (map[String(variantId)] || map[Number(variantId)]) return true;
    return Boolean(getStoqSellingPlan(variantId));
  }

  function applyStoqButton(variantId) {
    variantId = variantId || currentVariantId();
    if (variantId == null || variantId === '') return false;

    var isAnyButtonLoading = Boolean(document.querySelector('product-form .product-form__submit.loading'));
    var rr = window._RestockRocket;
    if (!isAnyButtonLoading && rr && typeof rr.renderButtonForVariant === 'function') {
      try {
        rr.renderButtonForVariant(String(variantId));
      } catch (error) {
        /* STOQ may throw before product context is ready */
      }
    }

    if (!isPreorderVariant(variantId)) return false;

    var plan = getStoqSellingPlan(variantId);
    var label = (plan && plan.preorder_button_text) || PREORDER_LABEL;

    document.querySelectorAll('product-form .product-form__submit').forEach(function (button) {
      var textEl = button.querySelector(':scope > span');
      if (textEl && textEl.textContent.trim() !== label) {
        textEl.textContent = label;
      }
      if (button.classList.contains('loading')) {
        button.querySelectorAll('.loading__spinner').forEach(function (spinner) {
          spinner.classList.remove('hidden');
        });
      } else {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
      }
      button.classList.add('restock-rocket-preorder-button');
    });

    return true;
  }

  function observeSubmitButtons() {
    if (observing || typeof MutationObserver === 'undefined') return;
    observing = true;

    document.querySelectorAll('product-form .product-form__submit').forEach(function (button) {
      if (button.dataset.yanaPreorderObserved) return;
      button.dataset.yanaPreorderObserved = 'true';
      new MutationObserver(function () {
        var variantId = currentVariantId();
        if (!isPreorderVariant(variantId)) return;
        var textEl = button.querySelector(':scope > span');
        var label = (getStoqSellingPlan(variantId) && getStoqSellingPlan(variantId).preorder_button_text) || PREORDER_LABEL;
        if (textEl && textEl.textContent.trim() !== label) {
          textEl.textContent = label;
        }
      }).observe(button, { childList: true, subtree: true, characterData: true });
    });
  }

  window.syncStoqPreorderButton = function (variantId) {
    variantId = variantId || currentVariantId();
    if (!variantId) return false;

    observeSubmitButtons();
    applyStoqButton(variantId);
    [0, 50, 150, 350, 700].forEach(function (delay) {
      setTimeout(function () {
        applyStoqButton(variantId);
      }, delay);
    });
    return isPreorderVariant(variantId);
  };

  document.addEventListener(
    'change',
    function (event) {
      if (event.target && event.target.matches && event.target.matches('product-form input[name="id"]')) {
        window.syncStoqPreorderButton(event.target.value);
      }
    },
    true
  );

  document.addEventListener('DOMContentLoaded', function () {
    mergePreorderMaps();
    observeSubmitButtons();
    window.syncStoqPreorderButton(currentVariantId());
  });

  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var payload = event && event.data;
    var variant = payload && payload.variant;
    if (variant) {
      document.dispatchEvent(
        new CustomEvent('variantChange', {
          bubbles: true,
          detail: { variant: variant },
        })
      );
      window.syncStoqPreorderButton(variant.id);
    }
    if (!payload || !payload.variant || !payload.sectionId) return;

    var container = document.getElementById('price-' + payload.sectionId);
    if (!container) return;

    var priceRoot = container.querySelector('.price');
    if (!priceRoot) return;

    var v = payload.variant;
    var compareAt = v.compare_at_price;
    var price = v.price;
    var volumePricing = priceRoot.getAttribute('data-volume-pricing') === 'true';

    var soldOut = !v.available;
    var hasCompareSale = compareAt != null && compareAt > price;

    priceRoot.classList.toggle('price--sold-out', soldOut);
    priceRoot.classList.toggle('price--on-sale', hasCompareSale && !volumePricing);
    priceRoot.classList.toggle('volume-pricing--sale-badge', hasCompareSale && volumePricing);
  });

  subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
    window.syncStoqPreorderButton(currentVariantId());
  });
})();
